<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

export default {
  page: {
    title: "Product Categories",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  data() {
    return {
      title: "Product Categories",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Product Categories",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsCategoriesServerPaginated: true,
      serverPerPage: 50,

      // Modal state
      currentModal: null,

      // Form validation
      nameError: "",

      // Form data
      data: {
        name: "",
      },
      editForm: {
        name: "",
        id: null,
      },

      deleteTarget: {
        name: "",
        id: null,
      },
      filterCategories: {
        search: "",
        page: 1,
        per_page: 50,
      },
      fields: [
        { key: "index", label: "S/N" },
        { key: "catName", label: "NAME" },
        { key: "addedBy", label: "ADDED By" },
        { key: "dateAdded", label: "DATE ADDED" },
        { key: "actions", label: "ACTIONS" },
      ],
      existingCategory: [],
      filter: null,
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", [
      "SaveStatus",
      "CategoriesPaginated",
      "CategoriesPagination",
      "FilterStatus",
      "CurrentCategoriesFilters",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),
    categoryColumns() {
      return this.fields;
    },

    rows() {
      return this.IsCategoriesServerPaginated
        ? this.CategoriesPagination.total
        : this.CategoriesPaginated
        ? this.CategoriesPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsCategoriesServerPaginated) {
          return (
            (this.CategoriesPagination && this.CategoriesPagination.per_page) ||
            this.filterCategories.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsCategoriesServerPaginated) {
          this.filterCategories.per_page = value;
          this.filterCategories.page = 1;
          this.FetchCategoriesData(this.filterCategories);
        }
      },
    },

    currentPage: {
      get() {
        return this.CategoriesPaginated && this.CategoriesPagination
          ? this.CategoriesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.IsCategoriesServerPaginated) {
          this.filterCategories.page = value;
          this.FetchCategoriesData(this.filterCategories);
        }
      },
    },
  },

  watch: {
    CategoriesPagination: {
      handler(newPagination) {
        if (
          newPagination &&
          newPagination.current_page > newPagination.last_page &&
          newPagination.last_page > 0
        ) {
          this.filterCategories.page = 1;
          this.FetchCategoriesData(this.filterCategories);
        }
      },
      deep: true,
    },

    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
          this.resetError();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchCategoriesData: "products/fetchPCategoriesData",
      AddCategory: "products/addPCategory",
      EditCategory: "products/editPCategory",
      DeleteCategory: "products/deletePCategory",
    }),

    async addCategory(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Category name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingCategory.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      this.AddCategory(this.data);
      this.FetchCategoriesData(this.filterCategories);
    },

    resetAdd() {
      this.data.name = "";
      this.nameError = "";
      this.currentModal = null;
    },

    resetEdit() {
      this.editForm.name = "";
      this.editForm.id = null;
      this.nameError = "";
      this.currentModal = null;
    },

    resetDelete() {
      this.deleteTarget.name = "";
      this.deleteTarget.id = null;
      this.currentModal = null;
    },

    showEditModal(data) {
      this.editForm.name = data.item.catName;
      this.editForm.id = data.item.id;
      this.nameError = "";
    },

    editCategory(modalId) {
      this.modal_id = modalId;
      this.EditCategory(this.editForm).then(() => {
        this.FetchCategoriesData(this.filterCategories);
      });
    },

    deleteCategory(modalId) {
      this.modal_id = modalId;
      this.DeleteCategory(this.deleteTarget).then(() => {
        this.FetchCategoriesData(this.filterCategories);
      });
    },

    showDeleteModal(data) {
      this.deleteTarget.name = data.item.catName;
      this.deleteTarget.id = data.item.id;
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    handleServerSearch() {
      this.filterCategories.page = 1;
      this.FetchCategoriesData(this.filterCategories);
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingCategory = (this.CategoriesPaginated || []).filter(
          (category) => {
            return (
              category.catName.toUpperCase() == this.data.name.toUpperCase()
            );
          }
        );
        if (this.existingCategory.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingCategory = [];
      }
    },

    resetError() {
      this.nameError = "";
    },
  },

  created() {
    this.FetchCategoriesData(this.filterCategories);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">All Product Categories</h4>
              </div>
              <div
                v-if="MyUserPerm && MyUserPerm.add_product_categories == 1"
                class="col-md-3"
                align="right"
              >
                <b-button v-b-modal.add-category-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <label>SEARCH CATEGORIES</label>
                <div class="input-group">
                  <b-form-input
                    v-model="filterCategories.search"
                    type="search"
                    placeholder="Search by category name..."
                    class="form-control form-control-sm"
                    @keyup.enter="handleServerSearch()"
                  ></b-form-input>
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="handleServerSearch()"
                    >
                      <b-spinner
                        v-if="FilterStatus"
                        variant="light"
                        small
                        label="Searching"
                      ></b-spinner>
                      <span>Search</span>
                    </button>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0 mt-3">
              <DataTable
                :columns="categoryColumns"
                :rows="CategoriesPaginated || []"
                :total-rows="rows"
                :pagination="CategoriesPagination"
                :server-pagination="IsCategoriesServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>

                <template #cell(catName)="{ row }">
                  {{ row.catName }}
                </template>

                <template #cell(addedBy)="{ row }">
                  {{ row.user ? row.user.name : "N/A" }}
                </template>

                <template #cell(dateAdded)="{ row }">
                  {{ row.dateAdded }}
                </template>

                <template #cell(actions)="{ row }">
                  <b-button-group>
                    <b-button
                      v-if="
                        MyUserPerm && MyUserPerm.edit_product_categories == 1
                      "
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-category-modal
                      @click="showEditModal({ item: row })"
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      v-if="
                        MyUserPerm && MyUserPerm.delete_product_categories == 1
                      "
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-category-modal
                      @click="showDeleteModal({ item: row })"
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal starts -->
    <b-modal id="add-category-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add New Product Category </template>
      <div class="form-group mb-3">
        <label>Category Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Category Name"
            class="form-control"
            @keyup="checkName"
            @input="resetError()"
            v-model="data.name"
          />
        </div>
        <div class="text-danger mt-1" v-if="nameError">
          <small
            ><em>{{ nameError }}</em></small
          >
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          @click="closeModal('add-category-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addCategory('add-category-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="edit-category-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Category</template>
      <div class="form-group mb-3">
        <label>Category Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError()"
            v-model="editForm.name"
          />
        </div>
        <div class="text-danger mt-1" v-if="nameError">
          <small
            ><em>{{ nameError }}</em></small
          >
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          @click="closeModal('edit-category-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editCategory('edit-category-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete category starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-category-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Category</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Are you sure you want to delete "<strong>{{
              deleteTarget.name
            }}</strong
            >"?
          </h5>
          <p class="text-muted mt-2">This action cannot be undone.</p>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          @click="closeModal('delete-category-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-times"></i> Cancel
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteCategory('delete-category-modal')"
          :disabled="SaveStatus"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
